import type { BifrostWeb } from '@seekrtech/bifrost-web'
import type { PurchasePayload, Result, Transaction } from '../types'
import type {
  NativeStorePricePayload,
  SubscriptionProduct,
} from '../products/types'

export interface IAPServiceMethods {
  getPrice: (payload: {
    product_id: number
    product_type: 'consumable' | 'subscription'
    sku: string
  }) => Promise<Result<NativeStorePricePayload, 'not found'>>

  // Native ≥ 5.19.0: discriminated on product_type; subscriptions carry an
  // offer (selected by offer_id). See @forest/paywall-core PurchasePayload and
  // docs/adr/0003.
  purchase: (
    payload: PurchasePayload,
  ) => Promise<
    Result<
      Transaction,
      | 'interrupted'
      | 'pending'
      | 'product not found'
      | 'invalid transaction'
      | 'unknown'
    >
  >

  closeTransaction: (payload: { transaction_id: string }) => Promise<void>

  getUnclosedTransaction: (payload: {
    product_id: number
    product_type: 'consumable' | 'subscription'
    sku: string
  }) => Promise<Result<{ transaction_id: string }, 'not found'>>

  getAllUnclosedTransactions: () => Promise<
    Result<{ transactions: Transaction[] }, 'not found'>
  >

  getAllEntitlements: () => Promise<
    Result<{ transactions: Transaction[] }, 'not found'>
  >

  getAvailableSubscriptionProducts: () => Promise<
    Result<{ products: SubscriptionProduct[] }, 'not found'>
  >

  getStoreRegion: () => Promise<Result<{ region: string }, 'not found'>>

  getReceiptSystemAccountId: () => Promise<
    Result<
      { receipt_system_account_id: string },
      'receipt system account id not available'
    >
  >
}

export function createIAPService(bifrost: BifrostWeb): IAPServiceMethods {
  return bifrost
    .createProxyBuilder<IAPServiceMethods>('IAPService')
    .withDefaultOptions({ timeout: 31_536_000_000 })
    .build()
}
